import { Component, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import {
  FirebaseService,
  isTemplateFullScreen
} from '@brightside-web/desktop/data-access/shared';

import {
  BsAuthService,
  BsHubService
} from "@brightside-web/desktop/data-access/core-services";

import { Subscription, from } from 'rxjs';

@Component({
    selector: 'brightside-web-verify-kba-intro',
    templateUrl: './verify-kba-intro.component.html',
    standalone: false
})
export class VerifyKbaIntroComponent implements OnInit, OnDestroy {
  private sub = new Subscription();

  processing = false;
  givenName = '';
  hasGivenName = false;
  pageOnForwardCtaPath = ['../', 'questions'];

  pageFromFullLayout = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private analytics: FirebaseService,
    private bsAuthService: BsAuthService,
    private bsHubService: BsHubService
  ) {}

  ngOnInit() {
    this.setUpHub();
    this.subscribeAndGetUserInfo();

    if (isTemplateFullScreen(this.activatedRoute)) {
      this.pageFromFullLayout = true;
    }
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  private setUpHub() {
    this.bsHubService.listen('ErrorChannel', () => {});
  }

  private subscribeAndGetUserInfo() {
    this.sub.add(
      from(this.bsAuthService.fetchUserAttributes()).subscribe(
        (attributes) => {
        this.givenName = attributes['first_name'] ?? '';
        this.hasGivenName = this.givenName ? true : false;
      })
    );
  }

  handleCancelCtaClick() {
    this.router.navigate(['home']);

    return false;
  }

  handleCtaClick() {
    this.analytics.logEvent('credit_kba_started');
    this.router.navigate(this.pageOnForwardCtaPath, { relativeTo: this.activatedRoute });
  }
}
